import { BuildersOverride, FilterBuilder } from './Types';

import { dateTSBuilder } from './builders/dateTSBuilder';
import { minimumStayMonthsBuilder } from './builders/minimumStayMonthsBuilder';
import { furnitureBuilder } from './builders/furnitureBuilder';
import { billsBuilder } from './builders/billsBuilder';
import { registrationBuilder } from './builders/registrationBuilder';
import { rulesBuilder } from './builders/rulesBuilder';
import { genderBuilder } from './builders/genderBuilder';
import { suitableForBuilder } from './builders/suitableForBuilder';
import { creationDateTSBuilder } from './builders/creationDateTSBuilder';
import { publishedDateTSBuilder } from './builders/publishedDateTSBuilder';
import { roomsBuilder } from './builders/roomsBuilder';
import { priceBuilder } from './builders/priceBuilder';
import { isSearchableBuilder } from './builders/isSearchableBuilder';
import { freePlacesBuilder } from './builders/freePlacesBuilder';
import { maximumStayBuilder } from './builders/maximumStayBuilder';
import { advertiserBuilder } from './builders/advertiserBuilder';
import { countryBuilder } from './builders/countryBuilder';
import { cityBuilder } from './builders/cityBuilder';
import { propertyTypeBuilder } from './builders/propertyTypeBuilder';
import { contractTypeBuilder } from './builders/contractTypeBuilder';
import { propertySizeBuilder } from './builders/propertySizeBuilder';
import { facilitiesBuilder } from './builders/facilitiesBuilder';
import { amenitiesBuilder } from './builders/amenitiesBuilder';
import { partnerBuilder } from './builders/partnerBuilder';
import { multiUnitListingsBuilder } from './builders/multiUnitListingsBuilder';
import { studapartBuilder } from './builders/studapartBuilder';

const defaultBuilders: BuildersOverride = {
  dateTS: dateTSBuilder,
  minimumStayMonths: minimumStayMonthsBuilder,
  propertyType: propertyTypeBuilder,
  propertySize: propertySizeBuilder,
  contractType: contractTypeBuilder,
  furniture: furnitureBuilder,
  bills: billsBuilder,
  registration: registrationBuilder,
  rules: rulesBuilder,
  gender: genderBuilder,
  suitableFor: suitableForBuilder,
  creationDateTS: creationDateTSBuilder,
  publishedDateTS: publishedDateTSBuilder,
  rooms: roomsBuilder,
  freePlaces: freePlacesBuilder,
  maximumStay: maximumStayBuilder,
  priceEUR: priceBuilder,
  isSearchable: isSearchableBuilder,
  advertiser: advertiserBuilder,
  country: countryBuilder,
  city: cityBuilder,
  facilities: facilitiesBuilder,
  amenities: amenitiesBuilder,
  partner: partnerBuilder,
  multiUnitListings: multiUnitListingsBuilder,
  studapart: studapartBuilder,
};

export const filterBuilder =
  (builders: BuildersOverride = {}): FilterBuilder =>
  (params, context) => {
    const buildersSet = { ...defaultBuilders, ...builders };

    const filterParts: string[] = Object.keys(buildersSet).map(key =>
      buildersSet[key](params, context),
    );

    return filterParts.filter(Boolean).join(' AND ');
  };
